import { AuthTokenPayload } from "@vertesia/common"
import { logEvent } from "firebase/analytics"

import { analytics } from "@plugins/session/auth/firebase"

export function useUXTracking() {
    const tagUserSession = async (user?: AuthTokenPayload) => {
        const signupData = window.localStorage.getItem("composableSignupData")

        if (!user) {
            return
        }

        if (signupData) {
            window.localStorage.removeItem("composableSignupData")
        }
    }

    const trackEvent = (eventName: string, eventProperties?: any) => {
        logEvent(analytics, eventName, { ...eventProperties, debug_mode: true })
    }

    return {
        tagUserSession,
        trackEvent,
    }
}
